import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=6cefc739"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountModal.vue?vue&type=style&index=0&id=6cefc739&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports